import { render, staticRenderFns } from "./CtaTwo.vue?vue&type=template&id=f061f97c&"
import script from "./CtaTwo.vue?vue&type=script&lang=js&"
export * from "./CtaTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports